import type { DetectedLink } from '../../integrations';

export function detectLinearLink(url: string): DetectedLink | null {
  const linearMatch = url.match(
    /https?:\/\/(?:app\.)?linear\.app\/([^/]+)\/issue\/([A-Z]+-\d+)/i
  );
  if (linearMatch) {
    return {
      url,
      integrationType: 'linear',
      resourceType: 'work-item',
      resourceId: linearMatch[2],
      workspaceId: linearMatch[1],
    };
  }
  return null;
}
